module.exports = "/_next/static/images/banner_title-8847f0986027373ed689dbdd6ad384d9.png";